import classNames from "classnames";
import type { ForwardRefExoticComponent } from "react";
import { useEffect, useRef } from "react";

type ConsumerProps = {
    className?: string;
};

export default function withSlideUpAnimation<P extends ConsumerProps>(ConsumerComponent: ForwardRefExoticComponent<P>) {
    return function WrappedWithSlideUpAnimation(props: P) {
        const { className, ...rest } = props;
        const animatedWrapperRef = useRef<HTMLDivElement | null>(null);

        useEffect(() => {
            const element = animatedWrapperRef.current;

            element?.addEventListener("animationend", handleAnimationEnd);

            function handleAnimationEnd() {
                element?.classList.remove("animated");
                element?.removeEventListener("animationend", handleAnimationEnd);
            }

            return () => {
                element?.removeEventListener("animationend", handleAnimationEnd);
            };
        }, []);

        return (
            <ConsumerComponent
                {...(rest as P)}
                ref={animatedWrapperRef}
                className={classNames(className, "animated")}
            />
        );
    };
}
